<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="addAppointment('')">新增</el-button>
			</div>
		</template>
		<el-table v-loading="loading" :data="list" tooltip-effect="dark" style="width: 100%">
			<el-table-column label="商品信息" min-width="320">
				<template v-slot="scope">
					<p v-for="(item,index) in scope.row.discount_goods" class="col">
						<span>
							商品名:{{scope.row.discount_goods[index].product_name}}
						</span>
						<span>
							商品版号:{{scope.row.discount_goods[index].product_model}}
						</span>
					</p>
				</template>
			</el-table-column>
			<el-table-column label="开始时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column label="开启状态">
				<template #default="scope">
					<el-switch v-model="scope.row.status" active-color="#409EFF" inactive-color="#F56C6C" :active-value="1"
					 :inactive-value="2" @change="changeEnabled(scope.row.status, scope.row.id)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template #default="scope">
					<el-button type="primary" size="mini" @click="editAppointment(scope.row)">编辑</el-button>
					<el-button type="warning" size="mini" @click="delAppointment(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</el-card>

	<el-dialog title="新作预约配置" v-model="dialogFormVisible">
		<div class="col">
			<el-form label-position="right" label-width="100px" :model="form" ref="form" :rules="rules">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="开始日期" prop="start_time">
							<el-input style="width: 220px;" v-model="form.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束日期" prop="end_time">
							<el-input style="width: 220px;" v-model="form.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-form-item label="商品选取" prop="discount_goods">
					<!-- <el-button v-slot="control">商品选取</el-button> -->
					<cs-product-select ref="newForm" dataType ='productAppointment' :check-list="form.discount_goods" @confirm='handleGoodsConfirm'>
					</cs-product-select>
				</el-form-item>

				<el-table :data="form.discount_goods">
					<el-table-column label="编号" prop="id"></el-table-column>
					<el-table-column label="商品名称" prop="product_name"></el-table-column>
					<el-table-column label="商品版号" prop="product_model"></el-table-column>
					<el-table-column label="操作">
						<template v-slot="scope">
							<el-button @click="remove(scope.$index)" type="text" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>



</template>

<script>
	import Upload from '../common/Upload.vue'
	import csProductSelect from '../common/cs-product-select.vue'
	export default {
		name: 'AppointmentList',
		components: {
			Upload,
			csProductSelect
		},
		data() {
			return {
				loading: false,
				list: [],
				dialogFormVisible: false,
				getData: [],
				form: {
					start_time: '',
					end_time: '',
					discount_goods: [],
				},
				rules: {
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			getAppointment() {
				this.loading = true;
				this.httpPost({
					url: '/admin/homeSetting/appointment_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res) => {
					this.list = res.data;
					this.loading = false;
				})
			},
			changeEnabled(status, id) {
				let select_id = id;
				let change_status = status;
				if (select_id) {
					this.loading = true;
					this.httpPost({
						url: '/admin/homeSetting/change_appointment_status',
						data: {
							id: select_id,
							status: change_status
						}
					}).then((res) => {
						if (res.code == 1) {
							this.$message.success(res.msg);
							this.loading = false;
						}
					})
				}
			},
			addAppointment(val) {
				this.form = {
					start_time: '',
					end_time: '',
					discount_goods: [],
				}
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
					// this.$refs.newForm.clear();
				})
			},
			editAppointment(val) {
				let temp = this.cloneObj(val);
				if (val) {
					temp.start_time = this.timestampToTime(temp.start_time);
					temp.end_time = this.timestampToTime(temp.end_time);
					this.form = temp;
				} else {
					this.resetObj(this.form);
				}
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
					// this.$refs.newForm.clear();
				})
			},
			delAppointment(val) {
				let id = val.id;
				this.msgBoxAjax(
					'提示',
					'确定删除吗？',
					"/admin/homeSetting/delAppointment", {
						id: id
					}).then((res) => {
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {

							this.getAppointment();
						});
					} else {

						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			submit() {
				if(this.form.discount_goods.length==0){
					this.$message.error('请至少设置一项新作预约');
					return false;
				}
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateAppointment();
					} else {
						console.log('error submit!')
						return false;
					}
				})

			},
			updateAppointment() {
				let id = this.form.id;
				if (!id) id = '';
				this.httpPost({
					url: '/admin/homeSetting/modify_appointment?id=' + id,
					data: this.form
				}).then((res) => {
					if (res.code == 1) {
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getAppointment();
					}
				})
			},
			handleGoodsConfirm(val) {
				let discount = []
				val.forEach(value => {
					discount.push({
						id: value.id,
						product_model: value.product_model,
						product_name: value.product_name,
					})
				})
				this.form.discount_goods = discount;
			},
			remove(index) {
				this.form.discount_goods.splice(index, 1)
			}
		},
		created() {
			this.getAppointment();
		}
	}
</script>

<style>
	.goods-image {

		/* width: 60px;
	  height: 60px; */
		width: 20%;
	}

	.model {
		margin: 0;
		font-size: 12px;
	}
</style>
